<div class="reject-lead">
    <header>
        <div class="col-sm-12 text-align header">
            Reject Lead
        </div>
    </header>
    <div>
        <form [formGroup]="RejectForm">
            <div class="">
                <!-- <div class="col-sm-12"> -->
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group col-sm-12">
                    <ng-container *ngFor="let sort of objectKeys(items); let i=index">
                        <br>
                        <span>{{sort}}:</span>
                        <br>
                        <div class="col-sm-12 row">
                            <mat-radio-button class="example-radio-button col-sm-5" *ngFor="let section of items[sort]"
                                [value]="section" (change)="onReasonRSelect(section.id)">
                                {{section.reason}}</mat-radio-button>
                        </div>
                    </ng-container>
                </mat-radio-group>
                <!-- </div> -->
            </div>
        </form>
    </div>
    <footer>
        <div class="col-sm-12 center ">
            <button class="close-action" (click)="closeDialog()">Cancel</button>
            <button class="create-action m-l-15" type="button" [disabled]="rejectData['reason'].length==0"
                (click)="confirmReject()">Confirm</button>
        </div>
    </footer>
</div>